<template>
  <div class="flex-center-container">
    <div class="flex-row">
      <input type="checkbox" id="isMonthly" class="black-text"
        v-model="isMonthly"
        @change="$emit('is-monthly', $event.target.checked)" />
      <label class="m-2">Recur Monthly?</label>
    </div>
    <div class="flex-row">
      <select class="drop-down"
        v-model="productSelectedId"
        @change="ddlChanged">
        <option disabled value="">Budget / Campaign</option>
        <option v-for="p in productPairs" v-bind:value="p.productId"
          :key="p.productId">{{p.productName}}</option>
      </select>
    </div>
    <div role="alert" class="has-text-danger">
      <span>{{error}}</span>
    </div>
  </div>
</template>

<style scoped>

.drop-down {
  @apply text-black;
}

.flex-row {
  @apply m-1;
}

</style>

<script>

import client from '../client/client'

export default {
  data () {
    return {
      isMonthly: this.defaultIsMonthly,

      productPairs: null,
      productSelected: null,

      error: null
    }
  },
  computed: {
    isOneTime: function () {
      return !this.isMonthly
    },
    // for the drop down (could have been any identifier, product or plan or price)
    productSelectedId: {
      get: function () {
        if(this.productSelected){
          return this.productSelected.productId
        } else {
          return null
        }
      },
      set: function (productId) {
        let matchSel = this.productPairs.filter((productPair) => {
          return productPair.productId === productId
        })
        this.productSelected = matchSel[0]
      }
    }
  },
  methods: {
    ddlChanged () {
      this.$emit('plan-selected-id', this.productSelected.planId)
      this.$emit('price-selected-id', this.productSelected.priceId)
    }
  },
  async mounted () {
      this.productPairs = await client.getProductPlansPrices()
  },
  props: {
    defaultIsMonthly: Boolean
  }
}

</script>
